import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';

import sx, { SxProp } from '../../internal/styles/sx';
import { TableProps } from './types';

const Table = styled('table', { shouldForwardProp })<TableProps & SxProp>(
  {
    boxSizing: 'border-box',
    borderCollapse: 'collapse',
    width: '100%',
    borderSpacing: 0,
    borderColor: 'transparent',
  },
  sx
);

export default Table;
